import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import AuthContext from "@/contexts/AuthContext";

const ClubSelect = () => {
  const navigate = useNavigate();
  const { userLoggedData, setSelectedClubId } = useContext(AuthContext);

  const clubs = useMemo(
    () => (Array.isArray(userLoggedData?.clubs) ? userLoggedData.clubs : []),
    [userLoggedData?.clubs],
  );

  const role = userLoggedData?.role?.toUpperCase?.() || "";

  const handleSelect = async (clubId) => {
    await setSelectedClubId(clubId);
    if (role === "ADMIN") {
      navigate(`/c/${clubId}/admin/dashboard`);
      return;
    }
    navigate(`/c/${clubId}/user/home`);
  };

  if (!userLoggedData) return null;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
        bgcolor: "background.default",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 520,
          p: 3,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={2}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 800 }}>
              Selecione um clube
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Escolha o clube para continuar.
            </Typography>
          </Box>

          {clubs.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Nenhum clube disponível para este usuário.
            </Typography>
          ) : (
            <Stack spacing={1}>
              {clubs.map((club) => (
                <Button
                  key={club?.id || club?.name}
                  variant="contained"
                  onClick={() => handleSelect(club?.id)}
                  disabled={!club?.id}
                  sx={{ justifyContent: "space-between", py: 1.25 }}
                >
                  <span>{club?.name || "Clube"}</span>
                  <span style={{ opacity: 0.85, fontWeight: 700 }}>
                    Entrar
                  </span>
                </Button>
              ))}
            </Stack>
          )}
        </Stack>
      </Paper>
    </Box>
  );
};

export default ClubSelect;

